import { render, staticRenderFns } from "./DanglingDbs.vue?vue&type=template&id=de97c942&scoped=true&"
import script from "./DanglingDbs.vue?vue&type=script&lang=ts&"
export * from "./DanglingDbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de97c942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de97c942')) {
      api.createRecord('de97c942', component.options)
    } else {
      api.reload('de97c942', component.options)
    }
    module.hot.accept("./DanglingDbs.vue?vue&type=template&id=de97c942&scoped=true&", function () {
      api.rerender('de97c942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DanglingDbs.vue"
export default component.exports